import TerminateBotDialog from './TerminateBotDialog'
export default TerminateBotDialog
